import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';
import { Reminder } from '@app/models/employee/reminder.model';

export class ReminderFrequencyColumn extends Column {
    title = 'table.employee-reminder.frequency';
    property = 'repeatOn';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(reminder: Reminder): string {
        switch (reminder.repeatOn) {
            case '1 year':
                return 'table.employee-reminder.everyYear';
            case '3 month':
                return 'table.employee-reminder.quarterly';
            case '1 month':
                return 'table.employee-reminder.everyMonth';
            case '2 week':
                return 'table.employee-reminder.everyTwoWeeks';
            case '1 week':
                return 'table.employee-reminder.everyWeek';
            case '1 day':
                return 'table.employee-reminder.everyDay';
            default:
                return 'table.employee-reminder.never';
        }
    }
}
